import { FormFieldsConfig } from "pages/components/Form/FormEntities";
import Countries from "pages/config/Countries";

const LocationConfig: FormFieldsConfig = {
  country: {
    default: Object.keys(Countries)[0],
    constraints: ["required"],
    options: Object.keys(Countries).map((code) => ({
      label: Countries[code].label,
      value: code,
    })),
  },

  city: {
    default: "",
    constraints: ["required"],
    options: [],
  },

  boxNumber: {
    default: "",
    constraints: ["required"],
  },
  box: {
    default: "",
  },

  address: {
    constraints: ["required"],
    formatter: 'capitalizeWords',
  },
};

export default LocationConfig;
